import { render, staticRenderFns } from "./Edo.vue?vue&type=template&id=941b3280&scoped=true"
import script from "./Edo.vue?vue&type=script&lang=js"
export * from "./Edo.vue?vue&type=script&lang=js"
import style0 from "./Edo.vue?vue&type=style&index=0&id=941b3280&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "941b3280",
  null
  
)

export default component.exports